import { select, showDistanceToPlace } from "@utils/function";

// get data from places
// search name_tracking
// check if lat/lng exist in json if not dont show element

function SearchPlaceInInformation() {
  const topSectionInfo = select(".top-section-info");
  const informationSearchClass = select(".information-search");

  if (!informationSearchClass) {
    topSectionInfo.insertAdjacentHTML(
      "afterbegin",
      createSearchInpuInInformation()
    );
  }

  const searchInput = select("#search-information");
  const resultPlace = select(".result-place");
  const sidebar = select(".sidebar");
  const informationContent = select(".information-content");

  document.addEventListener("click", (e) => {
    const target = e.target;
    e.stopPropagation();

    // click on clear button
    if (target.closest(".clear-search-information")) {
      clearResultAndRemoveTextInInput(searchInput);
    }

    // click on result item
    if (target.closest(".result-item")) {
      clearResultAndRemoveTextInInput(searchInput);
    }

    // click on result item and search input
    if (target === searchInput || target === resultPlace) {
      const searchInputWidth = searchInput.offsetWidth;
      const sidebarHeight = sidebar.clientHeight;
      const informationContentHeight =
        informationContent.clientHeight - sidebarHeight - 102;

      resultPlace.style = `
        --info-height: ${informationContentHeight}px;
        --info-width: ${searchInputWidth}px;
      `;

      searchInput.addEventListener("click", (e) => {
        if (resultPlace.childNodes.length > 0) {
          showHideAriaExpanded("remove", "true");
        }
      });

      searchInput.addEventListener("input", (e) => {
        e.stopPropagation();
        e.preventDefault();
        const getInputWith = searchInput.offsetWidth;

        resultPlace.style.width = `${getInputWith}px`;

        let value = e.target.value;

        if (value && value.trim().length > 0) {
          value = value.trim().toLowerCase();

          showHideAriaExpanded("remove", "true");

          setList(
            HQ.Properties.places.filter((element) => {
              // https://tree.taiga.io/project/eventhubhq-eventhubclient/issue/732
              // #1

              let mergeString = element.name + " " + element.keywords;

              return mergeString.match(new RegExp(value, "gi"));
            })
          );

          showHideButtonClear(true);
        } else {
          showHideButtonClear(false);
          showHideAriaExpanded("add", "false");
          clearList();
        }
        return;
      });
    } else {
      showHideButtonClear(false);
      showHideAriaExpanded("add", "false");
      clearList();
      const inputSearch = select("#search-information");
      inputSearch.value = "";
    }
  });
}

/**
 * Add or remove class hidden and change aria-expanded attribute
 *
 * @param {string} type
 * @param {string} attribute
 */
function showHideAriaExpanded(type, attribute) {
  const resultPlace = select(".result-place");
  const searchInput = select("#search-information");

  resultPlace.classList[type]("hidden");
  searchInput.setAttribute("aria-expanded", attribute);
}

/**
 * Set list with results
 *
 * @param {array} results
 */
function setList(results) {
  clearList();

  // TODO: add distance and sort by distance

  results = addDistanceToAllPlaces(results);

  for (const row of results) {
    createRow(row);
  }
}

function addDistanceToAllPlaces(results) {
  const informationContentHead = select(".information-content");
  const sortType = informationContentHead.dataset.sort;

  let newArray = results.map((el) => {
    // remove TEE OFF from hole sub menu
    // if (el.id === 19 || el.id === 20) return;

    const { latitude, longitude, hole } = el || {};

    if (isNaN(latitude) || isNaN(longitude)) {
      return;
    }

    // create new array with distance
    let showDistance = showDistanceToPlace(
      `${latitude},${longitude}`,
      hole,
      HQ.Properties.distanceUnit
    );

    // if distance is string and include "/" split and get first element
    // this is for sort by distance
    if (typeof showDistance === "object") {
      let { distanceTee, distanceGreen } = showDistance;

      // get smalest number from distanceTee and distanceGreen
      showDistance = Math.min(distanceTee, distanceGreen);
    }

    return {
      ...el,
      distance: el.latitude ? showDistance : 0,
    };
  });

  // sort children depence on sortType
  if (sortType == 1) {
    newArray.sort((a, b) => a.distance - b.distance);
  } else if (sortType == 3) {
    newArray.sort((a, b) => a.name.localeCompare(b.name));
  }

  return newArray;
}

/**
 * Show or hide button clear
 *
 * @param {boolean} show
 */
function showHideButtonClear(show) {
  const clearSearchInformationButton = select(".clear-search-information");
  clearSearchInformationButton.classList[show ? "remove" : "add"]("hidden");
}

/**
 * Clear result and remove text in input
 *
 * @param {HTMLElement} searchInput
 */
function clearResultAndRemoveTextInInput(searchInput) {
  searchInput.value = "";
  clearList();
  showHideButtonClear(false);
}

/**
 * Clear list
 */
function clearList() {
  const resultPlace = select(".result-place");
  resultPlace.innerHTML = "";
}

/**
 * Create row for result list
 *
 * @param {object} row
 */
function createRow(row) {
  // if lat/lng is not exist dont show element
  if (!row?.latitude || !row?.longitude) return;

  const { latitude, longitude, icon, parent_id, id, name } = row;

  if (!latitude || !longitude) return;

  const youLatLng = document.documentElement.style.getPropertyValue("--lat");

  let hole;
  if (icon === "icon-hole") {
    hole = row.hole;
  }

  let distanceToPlace = showDistanceToPlace(
    `${latitude},${longitude}`,
    hole,
    HQ.Properties.distanceUnit
  );

  let distanceToShow = distanceToPlace;

  const distanceUnitShort = HQ.Properties.distanceUnit === "metres" ? "m" : "y";

  // if distance is string and include "/" split
  // this for tee and green and add unit [tee/green]
  if (typeof distanceToShow === "object") {
    // const addInfoTee = index === 0 ? " (Tee)" : "";
    // const addInfoGreen = index === 0 ? " (Green)" : "";

    const { distanceTee, distanceGreen } = distanceToShow;

    // distanceToPlace = `${distanceTee}${distanceUnitShort}${addInfoTee} / ${distanceGreen}${distanceUnitShort}${addInfoGreen}`;
    distanceToPlace = `${distanceTee}${distanceUnitShort} / ${distanceGreen}${distanceUnitShort}`;
  } else {
    // add unit to distance place
    distanceToPlace = `${distanceToPlace}${distanceUnitShort}`;
  }

  // if distance is less than 10 show <10m or <10y
  const dist =
    distanceToPlace <= 10 ? `<10${distanceUnitShort}` : `${distanceToPlace}`;

  const showDistance =
    youLatLng && latitude
      ? `<div class="ms-auto me-2 distance-to-place">${dist}</div>`
      : "";

  const showIDIfSuperAdmin = HQ.Properties.userType ? ` (${id})` : "";
  const dataLatlng = `data-latlng="${latitude},${longitude}"`;
  const dataPlaceId = `data-place-id="${id}"`;
  const dataIdParent = `data-id-parent="${parent_id}"`;
  const dataTrackingName = `data-tracking-name="${name}"`;

  const className =
    'class="d-flex align-items-center open-place information-children"';

  const templateRow = `
    <div ${dataLatlng} ${dataPlaceId} ${dataIdParent} ${dataTrackingName} ${className}>
      <div class="text-content">${name}${showIDIfSuperAdmin}</div>
      ${showDistance}
    </div>
  `;

  const resultItem = document.createElement("li");
  resultItem.classList.add("result-item");
  resultItem.insertAdjacentHTML("beforeend", templateRow);
  list.appendChild(resultItem);
}

/**
 * Create search input in information
 *
 * @returns HTMLElement
 */
function createSearchInpuInInformation() {
  const searchInformation = `
    <div class="information-search">
        <div class="d-flex align-items-center">
        <input type="text" id="search-information" autocomplete="off" placeholder="Search place" class="form-control" aria-expanded="false">
        </div>
        <button class="clear-search-information hidden" aria-label="Clear search"></button>
        <ul class="result-place list-unstyled hidden" id="list"></ul>
    </div>
    `;

  return searchInformation;
}

export default SearchPlaceInInformation;
